import React, { useState } from "react";
import SpatialInput from "./SpatialInput";
import WaitlistModal from "./WaitlistModal";

const CTASection = () => {
  const [open, setOpen] = useState(false);

  return (
    <section className="relative w-full py-40 bg-white overflow-hidden border-t border-zinc-200">

      {/* BACKGROUND VIDEO */}


      {/* --- BACKGROUND GRID (Swiss/Tech) --- */}
      <div className="absolute inset-0 pointer-events-none opacity-20 bg-[linear-gradient(90deg,#ccc_1px,transparent_1px),linear-gradient(#ccc_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,#000_70%,transparent_100%)]" />

      <div className="container relative z-10 mx-auto px-8 lg:px-16 flex flex-col items-center">

        {/* 2. THE SPATIAL INPUT CONTAINER */}
        <div className="w-full max-w-4xl h-[160px] relative group flex items-start justify-center pt-10">
          {/* Prompt Input */}
          <div className="w-full">
            <SpatialInput
              className="shadow-2xl shadow-zinc-200 bg-white/50 backdrop-blur-md border border-zinc-200"
              onSubmit={() => setOpen(true)}
            />
          </div>
        </div>

        {/* 4. THE HEADING */}
        <div className="text-center relative mt-12">
          <h2 className="font-sans font-bold text-[32px] leading-[0.9] text-zinc-900 tracking-tighter mb-6">What will you create?</h2>
        </div>

        {/* --- WAITLIST MODAL --- */}
        <WaitlistModal open={open} setOpen={setOpen} />

      </div>
    </section>
  );
};

export default CTASection;